import React, { useEffect, useState } from 'react'
import useForm from '../../../hooks/useForm';
import { useDoneFetchActions } from '../../../hooks/useDoneFetchActions';
import { getCuposByPlanta, getPlantas, getRutasByPlanta } from '../../../services/adminServices';
import Select, { CSSObjectWithLabel } from 'react-select'
import { getTinas } from '../../../services/tinaServices';

interface props {
  runSearch: (values: PlantaFechaFilterProps) => void;
  initialValuesFilter?: Partial<PlantaFechaFilterProps>;
  hideTina?: boolean; // Evidelis lo colocó para que los depositos no se vean en la página de gráficas de movimiento
  hideIntervalo?: boolean; // Evidelis lo colocó para el nuevo filtro de intervalo de tiempo
  isGraficasMovimiento?: boolean; // Para saber si está en GraficasMovimiento

  //Alertas
  hideFechaIni?: boolean; // <-- NUEVO
  limiteDeCupos?: () => void; // Para manejar límite de cupos


}

export interface PlantaFechaFilterProps {
  fechaFin: string,
  fechaIni: string,
  planta: number,
  ruta: number,
  cupo?: number,
  intervalo: string; // Intervalo de tiempo: 'diario', 'semanal', 'quincenal', 'mensual'
  tina: number

}
export const PlantaFechas = ({ runSearch, initialValuesFilter = {}, hideTina = false, hideIntervalo = false, isGraficasMovimiento = false, hideFechaIni = false, limiteDeCupos = undefined, }: props) => {

  // Evidelis lo colocó para que los depositos no se vean en la página de gráficas de movimiento


  const doneFetchActions = useDoneFetchActions();

  const { handleInputChange, formValues, changeMulti } = useForm(initialValuesFilter as PlantaFechaFilterProps);
  const [rutas, setRutas] = useState([{ id: 0, nombre: '' }])
  const [Tinas, setTinas] = useState([{ id: 0, nombre: '' }])
  const [plantas, setPlantas] = useState([{ id: 0, nombre: '' }])
  const [cupos, setCupos] = useState<Array<{ value: string; label: string; }>>()

  useEffect(() => {
    doneFetchActions(getPlantas()).then((resp: [{ id: 0, nombre: '' }]) => {
      setPlantas(resp);
    })
    doneFetchActions(getTinas({})).then(({ rows }) => {
      setTinas(rows.map((r: any) => ({ id: r.id, nombre: r.nombre_tina })))
    })
  }, [doneFetchActions])

  useEffect(() => {
    if (formValues.planta) {
      doneFetchActions(getRutasByPlanta(formValues.planta)).then((resp: [{ id: 0, nombre: '' }]) => {
        setRutas(resp)
      })
    } else {
      setRutas([])
    }
    changeMulti({ ruta: 0, cupo: 0 })
  }, [formValues.planta, doneFetchActions, changeMulti])

  useEffect(() => {
    doneFetchActions(getCuposByPlanta({ planta: formValues.planta, ruta: formValues.ruta })).then((resp: [{ id: string; codigo: string }]) => {
      setCupos(resp.map(ob => ({ value: String(ob.id), label: String(ob.codigo) })))
    })
    changeMulti({ cupo: 0 })
  }, [formValues.ruta, formValues.planta, doneFetchActions, changeMulti])

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    runSearch(formValues);

  }
  return (
    <form onSubmit={handleSubmit}>
      <div className='row g-3 align-items-center text-center m-auto'>
        <div className="col" style={{ minWidth: '12rem' }}>
          <div className="form-floating mb-3">
            <select
              className="form-select form-select-lg"
              id="planta"
              name="planta"
              value={formValues.planta}
              onChange={handleInputChange}
            >
              <option value={0} >Todas las plantas</option>
              {plantas.map(p => <option key={`plata_${p.id}`} value={p.id}>{p.nombre}</option>)}
            </select>
            <label htmlFor="planta">Plantas:</label>
          </div>
        </div>
        <div className="col" style={{ minWidth: '12rem' }}>
          <div className="form-floating mb-3">
            <select
              className="form-select form-select-lg"
              id="ruta"
              name="ruta"
              value={formValues.ruta}
              onChange={handleInputChange}
            >
              <option value={0} >Todas las rutas</option>
              {rutas.map(p => <option key={`ruta_${p.id}`} value={p.id}>{p.nombre}</option>)}
            </select>
            <label htmlFor="ruta">Rutas:</label>
          </div>
        </div>

        {!hideTina && ( // Evidelis lo colocó - Modifiqué para que los depositos no se vean en la página de gráficas de movimiento
          <div className="col" style={{ minWidth: '12rem' }}>
            <div className="form-floating mb-3">
              <select
                className="form-select form-select-lg"
                id="tina"
                name="tina"
                value={formValues.tina}
                onChange={handleInputChange}
              >
                <option value={0} >Todos los depositos</option>
                {Tinas.map(p => <option key={`tina_${p.id}`} value={p.id}>{p.nombre}</option>)}
              </select>
              <label htmlFor="tina">Depositos:</label>
            </div>
          </div>
        )}

        <div className="col" style={{ minWidth: '12rem' }}>
          <div className="form-floating mb-3">
            <Select
              className='form-select'
              placeholder=''
              classNamePrefix='react-select-btsp'
              noOptionsMessage={() => 'Cupos no encontrados'}
              isClearable
              options={cupos || []}
              value={isGraficasMovimiento
                ? (cupos || []).filter(cp => Array.isArray(formValues.cupo)
                  ? formValues.cupo.includes(cp.value)
                  : String(formValues.cupo) === cp.value)
                : (cupos || []).find(cp => String(formValues.cupo) === cp.value) || { value: '' }
              }
              onChange={(selected) => {
                if (selected === null) {
                  handleInputChange({ target: { name: 'cupo', value: '', type: 'select' } })
                  return;
                }
                const selectedValues = Array.isArray(selected) ? selected : [selected];

                if (isGraficasMovimiento && selectedValues.length > 5) {
                  if (limiteDeCupos) limiteDeCupos();
                  return;
                }


                handleInputChange({
                  target: {
                    name: 'cupo',
                    value: isGraficasMovimiento
                      ? selectedValues.map(item => item.value)
                      : selectedValues[0].value,
                    type: 'select'
                  }
                });
              }}
              isMulti={isGraficasMovimiento}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 } as CSSObjectWithLabel),
                control: (base) => ({
                  ...base,
                  overflow: 'hidden',
                  maxWidth: '100%',
                  minHeight: '38px',
                  height: 'auto',
                } as CSSObjectWithLabel),

                valueContainer: (base) =>
                  isGraficasMovimiento
                    ? ({
                      ...base,
                      width: '100%',
                      maxWidth: '100%',
                      overflowX: 'auto',
                      overflowY: 'hidden',
                      display: 'flex',
                      flexWrap: 'nowrap',
                      boxSizing: 'border-box',
                      alignItems: 'center',
                      paddingBottom: '0px',
                    } as CSSObjectWithLabel)
                    : base,

                multiValue: (base) =>
                  isGraficasMovimiento
                    ? ({
                      ...base,
                      minWidth: 'auto',
                      maxWidth: 'auto',
                      padding: '0 4px',
                      marginRight: '2px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '0.8rem',
                      whiteSpace: 'nowrap',
                    } as CSSObjectWithLabel)
                    : base,


                multiValueLabel: (base) =>
                  isGraficasMovimiento
                    ? ({
                      ...base,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      maxWidth: '40px'
                    } as CSSObjectWithLabel)
                    : base
              }}

            />
            <label htmlFor="id_cupo_filtro">Cupo</label>
          </div>
        </div>


        {/*//Alertas */}
        {!hideFechaIni && (
          <div className="col" style={{ minWidth: '12rem' }}>
            <div className="form-floating mb-3">
              <input
                type="date"
                id="fechaIni"
                name="fechaIni"
                value={formValues.fechaIni}
                onChange={handleInputChange}
                className="form-control form-control-lg"
              />
              <label htmlFor="fechaIni">Fecha inicial:</label>
            </div>
          </div>
        )}

        <div className="col" style={{ minWidth: '12rem' }}>
          <div className="form-floating mb-3">
            <input
              type="date"
              id="fechaFin"
              name="fechaFin"
              value={formValues.fechaFin}
              onChange={handleInputChange}
              className="form-control form-control-lg"
            />
            <label htmlFor="fechaFin">{hideFechaIni ? 'Fecha:' : 'Fecha final:'}</label>
          </div>
        </div>


        {/* Filtro de intervalo de tiempo - EVidelis lo colocó*/}
        {!hideIntervalo && (
          <div className="col" style={{ minWidth: '12rem' }}>
            <div className="form-floating mb-3">
              <select
                className="form-select form-select-lg"
                id="intervalo"
                name="intervalo"
                value={formValues.intervalo}
                onChange={handleInputChange}
              >
                <option value="diario">Diario</option>
                <option value="semanal">Semanal</option>
                <option value="quincenal">Quincenal</option>
                <option value="mensual">Mensual</option>
              </select>
              <label htmlFor="intervalo">Intervalo de tiempo:</label>
            </div>
          </div>
        )}


        <div className="col mt-0">
          <button type="submit" className="btn btn-lg btn-primary">
            <span className="icon-search"></span>
          </button>
        </div>
      </div>
    </form>
  )
}
